import { AxInit, ModuleName } from "../../../Lib/AxSystem/AxInit";
import { ProductMapper } from "../../../Lib/Mapper/ProductMapper";
import { AxLimeStone } from "../../../Limestone/AxLimeStone";
import { IAddToCartRequest } from "../../../Models/Package/IAddToCartRequest";
import { AxProdInitData, PreDateable } from "../Abstraction/PreDateable";

@ModuleName("AxPackPredateable")
export class AxPackPredateable extends PreDateable implements AxInit {
    private ProjNr: number;
    private TariffSheetNr: number;
    private PackageNr: number;


    constructor(private _ProductMapper = new ProductMapper(),
        private _AxLimestone = new AxLimeStone()) {
        super();
    }

    AxInit(initData: AxProdInitData): void {
        this.ProjNr = initData.ProjNr;
        this.TariffSheetNr = initData.ProductGroupIdentifier;
        this.PackageNr = initData.Id;

        this.Init(initData);

        $('.prod_selection__persontype-submit').click(e => {
            this._AxLimestone.LockButton(e.delegateTarget);
            this.ToSummary();
        });
    }

    ToSummary(): void {
        if (this.CheckSubmit()) {
            let requestObj: IAddToCartRequest = {
                Date: this.ActivateDate.format('YYYY-MM-DD'),
                ProjNr: this.ProjNr,
                PackTariffSheetNo: this.TariffSheetNr,
                PackageNr: this.PackageNr,
                PackagePositions: this._ProductMapper.GetPackagePositionList(this._TicketList.ProductList),
            };
            this._summaryRedirect.redirect(this.PostURL, requestObj, false);
        }
    }
}
